import { motion } from "framer-motion";

// One subtle, fast fade-up used for every route. Keeps navigation feeling
// responsive and consistent instead of the old per-route flip/bounce mix.
const fadeUp = {
  initial: {
    opacity: 0,
    y: 16,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
  exit: {
    opacity: 0,
    y: -8,
    transition: {
      duration: 0.2,
      ease: "easeIn",
    },
  },
};

const PageTransition = ({ children }) => {
  const prefersReducedMotion =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const disableAnimations =
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_DISABLE_ANIMATIONS === "true";

  if (prefersReducedMotion || disableAnimations) {
    return <div className="w-full">{children}</div>;
  }

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={fadeUp}
      className="w-full"
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
